<template>
  <!-- NOTE (TEMPLATE) to show & edit reasercher profile -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <Profile />
  </div>
</template>

<script>
import Profile from "../../components/Profile";

export default {
  components: {
    Profile
  }
};
</script>
